import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import CustomerMenu from "@/pages/CustomerMenu";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderTracking from "@/pages/OrderTracking";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerProfile from "@/pages/CustomerProfile";
import AdminLogin from "@/pages/AdminLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ConfirmUpi from "@/pages/ConfirmUpi";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminHistory from "@/pages/admin/AdminHistory";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminFloor from "@/pages/admin/AdminFloor";
import AdminWaiter from "@/pages/admin/AdminWaiter";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminStaff from "@/pages/admin/AdminStaff";
import SuperConsole from "@/pages/admin/SuperConsole";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/m/:token" element={<CustomerMenu />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order/:orderId" element={<OrderTracking />} />
          <Route path="/login" element={<CustomerLogin />} />
          <Route path="/profile" element={<CustomerProfile />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/confirm-upi" element={<ConfirmUpi />} />
          <Route path="/super" element={<SuperConsole />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="history" element={<AdminHistory />} />
            <Route path="menu" element={<AdminMenu />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="floor" element={<AdminFloor />} />
            <Route path="tables" element={<Navigate to="/admin/floor" replace />} />
            <Route path="waiter" element={<AdminWaiter />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="staff" element={<AdminStaff />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
